import { render } from "./WidgetSxImage.vue?vue&type=template&id=3017a091"
import script from "./WidgetSxImage.vue?vue&type=script&lang=js"
export * from "./WidgetSxImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__